export default __webpack_public_path__ + "60984a92d81c9fbf9f31b47974aa8239.png";